import * as React from 'react';
import moment from 'moment';
import SortableTbl from 'react-sort-search-table';

import { StyledCard } from './CourseTracker.styles';


interface IProps {
  data?: any;
  selectedCourse?: string,
  completedLessons?: any,
}

const CompletionTD = (props: any) => <td>{props.tdData ? '100' : '0'}%</td>;
const LastAttemptTD = (props: any) => <td>{moment(props.tdData).format('ll')}</td>;
const ScoreTD = (props: any) => {
  const { tdData } = props;
  const className = tdData < 50 ? 'red' : 'yellow';

  return <td className={className}>{tdData ? tdData.toFixed() : '-'}%</td>;
}

class CourseTracker extends React.Component<IProps> {
  public state = {};

  constructor(props) {
    super(props);
  }

  public render() {
    const { data, selectedCourse, completedLessons } = this.props;
    const col = [ 'Title', 'Attempts', 'LastAttempt', 'Completed', 'BestScore' ];
    const tHead = [ 'Lesson Name', 'Attempts', 'Last Attempt', 'Completion', 'Best Score' ];

    if (!selectedCourse) { return null; }

    return (
      <StyledCard scrollable={true} title="Your Course Tracker">
        <SortableTbl
          dKey={col}
          tHead={tHead}
          defaultCSS={false}
          tblData={completedLessons}
          search={false}
          paging={false}
          customTd={[
            { custd: LastAttemptTD, keyItem: 'LastAttempt' },
            { custd: CompletionTD, keyItem: 'Completed' },
            { custd: ScoreTD, keyItem: 'BestScore' },
          ]}
        />
      </StyledCard>
    );
  }
}

export default CourseTracker;



// WEBPACK FOOTER //
// ./src/components/DataCentre/CourseTracker/CourseTracker.tsx